export const LANGS = ['ja', 'en'];
export const DEFAULT_LANG = 'ja';
const COOKIE_NAME = 'emarf_lang';

const cookieDomain = () => {
  if (typeof location === 'undefined') return '';
  const host = location.hostname;
  if (host.endsWith('.emarf.co') || host === 'emarf.co') return '.emarf.co';
  if (host.endsWith('.emarf.local') || host === 'emarf.local') return '.emarf.local';
  return host;
};

const isLang = (v) => !!v && LANGS.indexOf(v) !== -1;

const readCookieLang = () => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
  const v = match ? decodeURIComponent(match[1]) : null;
  return isLang(v) ? v : null;
};

const readQueryLang = () => {
  if (typeof location === 'undefined') return null;
  const params = new URLSearchParams(location.search);
  const v = params.get('lang');
  return isLang(v) ? v : null;
};

const stripLangQuery = () => {
  if (typeof location === 'undefined' || typeof history === 'undefined') return;
  const url = new URL(location.href);
  if (!url.searchParams.has('lang')) return;
  url.searchParams.delete('lang');
  history.replaceState(history.state, '', url.toString());
};

export const writeLang = (lang) => {
  if (typeof document === 'undefined') return;
  const domain = cookieDomain();
  const domainAttr = domain ? `; Domain=${domain}` : '';
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(lang)}; Path=/${domainAttr}; Max-Age=31536000; SameSite=Lax`;
};

export const readLang = () => {
  const fromQuery = readQueryLang();
  if (fromQuery) {
    writeLang(fromQuery);
    stripLangQuery();
    return fromQuery;
  }
  return readCookieLang() || DEFAULT_LANG;
};



// WEBPACK FOOTER //
// ./src/utils/lang.js